import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/components/founder-profile-card.tsx");
